import { View } from 'react-native'
import { useTranslation } from 'react-i18next'
import cn from '@ui/utils/cn'
import Typography from '@ui/typography'
import Price from '@/price/Price/Price'
import { leadingNone } from '@ui/typography/styles'
import { TypographyProps } from '@ui/typography/types'
import { PriceSummaryProps as Props, useTextTemplate } from './types'
import Loader from '@ui/elements/Loader'
import { colors } from '@ui/colors'

export default function PriceSummary({
  price,
  priceBefore,
  template,
  installment,
  className,
  isLoading,
  ...props
}: Props) {
  const { t } = useTranslation(['steps'])
  const text = useTextTemplate(template)

  const textProps = {
    variant: 'SMB',
    className: 'color-text/25 uppercase h-6 items-center flex',
  } satisfies TypographyProps

  const textTop = props.textTop || text.top
  const textBottom = props.textBottom || text.bottom

  const hasLoading = isLoading !== undefined

  return (
    <View
      className={cn('flex flex-col items-end gap-1 px-16 py-16', className)}
    >
      {!!textTop && <Typography {...textProps}>{textTop}</Typography>}
      {!!priceBefore && (
        <Typography
          variant="MD"
          className={cn(
            leadingNone,
            'flex h-6 items-center line-through color-red-700'
          )}
        >
          <Price value={priceBefore} />
        </Typography>
      )}
      <View className="flex flex-row items-end gap-1">
        <View className="flex flex-row items-center gap-2">
          {hasLoading !== undefined && (
            <Loader iconProps={{ strokeWidth: 3 }} loading={!!isLoading} />
          )}
          <Typography
            variant="XLB"
            className={leadingNone}
            color={hasLoading && isLoading ? colors.black25 : colors.text}
          >
            <Price showZero value={price ? Math.max(price, 0) : undefined} />
          </Typography>
        </View>
        {!!installment && (
          <Typography variant="LG" className={leadingNone}>
            {t(`steps:priceSuffix.${installment}.medium`)}
          </Typography>
        )}
      </View>
      {!!textBottom && <Typography {...textProps}>{textBottom}</Typography>}
    </View>
  )
}
